/**
 * Floating Items Button
 *
 * FAB-style button for opening the items modal during raid draft phase.
 * Shows a bag icon with badge count of available usable items.
 */

import classNames from "classnames";

interface FloatingItemsButtonProps {
  totalItems: number;
  onClick: () => void;
  disabled?: boolean;
}

export const FloatingItemsButton = ({
  totalItems,
  onClick,
  disabled = false,
}: FloatingItemsButtonProps) => {
  const hasItems = totalItems > 0;

  return (
    <button
      onClick={onClick}
      disabled={disabled || !hasItems}
      className={classNames(
        "relative w-14 h-14 rounded-full shadow-lg transition-all duration-200",
        "flex items-center justify-center",
        "border-3 border-pk-gray-2",
        {
          "bg-pk-purple-3 hover:bg-pk-purple-4 hover:scale-105 active:scale-95":
            hasItems && !disabled,
          "bg-pk-gray-3 opacity-50 cursor-not-allowed": !hasItems || disabled,
        },
      )}
      aria-label={`Open items (${totalItems} available)`}
    >
      {/* Bag Icon */}
      <svg
        viewBox="0 0 24 24"
        className="w-7 h-7 text-white drop-shadow-md"
        fill="currentColor"
      >
        <path d="M12 2C9.24 2 7 4.24 7 7H5C3.9 7 3 7.9 3 9V20C3 21.1 3.9 22 5 22H19C20.1 22 21 21.1 21 20V9C21 7.9 20.1 7 19 7H17C17 4.24 14.76 2 12 2ZM12 4C13.66 4 15 5.34 15 7H9C9 5.34 10.34 4 12 4ZM12 12C10.34 12 9 10.66 9 9H7C7 11.76 9.24 14 12 14S17 11.76 17 9H15C15 10.66 13.66 12 12 12Z" />
      </svg>

      {/* Badge Count */}
      {hasItems && (
        <div
          className={classNames(
            "absolute -top-1 -right-1 min-w-[22px] h-[22px] px-1",
            "bg-pk-red-4 border-2 border-pk-gray-1 rounded-full",
            "flex items-center justify-center",
            "text-white text-xs font-bold shadow-md",
          )}
        >
          {totalItems > 99 ? "99+" : totalItems}
        </div>
      )}
    </button>
  );
};

